import { request } from "./platformshClient";

export const constructNewUrl = async url => {
  // make it so it accounts for env pages.
  const params = url.split("/").filter(param => param !== "");
  const firstParam = params[0];
  const lastParam = params[params.length - 1];

  if (firstParam !== "projects") {
    return "https://accounts.platform.sh/";
  }

  const isProjectSettings = params.length === 3 && lastParam === "edit";
  const projectId = params[1];
  const environmentId = params.length > 3 ? params[3] : "";
  const isEnvironmentSettings = environmentId && lastParam === "edit";
  const project = await request(`https://api.platform.sh/locate/${projectId}`);
  const newUiProject = `https://console.platform.sh/${
    project.owner_info.username
  }/${projectId}`;

  if (isProjectSettings) {
    return `${newUiProject}/settings`;
  }

  if (isEnvironmentSettings) {
    return `${newUiProject}/${environmentId}/settings`;
  }

  return `${newUiProject}`;
};

export const redirectAfterToggle = async currentUrl => {
  const redirect = await constructNewUrl(currentUrl);
  window.location = redirect;

  if (redirect) {
    window.location = redirect;
  }
};



// WEBPACK FOOTER //
// ./src/utils.js